'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _telephoneModal = require('../../src/styles/telephone-modal.scss');

var _telephoneModal2 = _interopRequireDefault(_telephoneModal);

require('../../src/styles/external.scss');

require('../../src/styles/vars.scss');

var _doctifyModal = require('./doctify-modal');

var _doctifyModal2 = _interopRequireDefault(_doctifyModal);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import messages from '../lang/default-messages';

var TelephoneModal = function TelephoneModal(props) {
	return _react2.default.createElement(
		_doctifyModal2.default,
		(0, _extends3.default)({}, props, {
			className: props.className + ' ' + _telephoneModal2.default.telephoneModal,
			bodyStyles: _telephoneModal2.default.body,
			header: _react2.default.createElement(
				'span',
				{ className: _telephoneModal2.default.header },
				_react2.default.createElement('i', { className: 'ion-ios-telephone' }),
				'Call Specialist'
			) }),
		props.numbers.length > 0 && props.numbers.map(function (number, index) {
			return _react2.default.createElement(
				'div',
				{ key: index, className: _telephoneModal2.default.practice },
				number.practice_name && number.practice_name.length > 0 && _react2.default.createElement(
					'span',
					null,
					number.practice_name + ':'
				),
				_react2.default.createElement(
					'span',
					null,
					_react2.default.createElement(
						'a',
						{ className: _telephoneModal2.default.telephoneNumber,
							href: 'tel:' + number.number,
							onClick: function onClick() {
								if (window.innerWidth <= 767) {
									(0, _doctifyUtils.fireGTMevent)('lead_submit_reveal');
									(0, _doctifyUtils.fireGTMevent)('telephone_call_mobile');
								}
							} },
						number.number
					)
				)
			);
		}),
		props.numbers.length === 0 && _react2.default.createElement(
			'span',
			null,
			'This specialist has not listed any contact numbers.'
		)
	);
};
// import { FormattedMessage } from 'react-intl';

TelephoneModal.propTypes = {
	className: require('react').PropTypes.any,
	numbers: require('react').PropTypes.arrayOf(require('react').PropTypes.any)
};


TelephoneModal.displayName = 'TelephoneModal';

TelephoneModal.defaultProps = {
	className: 'telephoneModal',
	numbers: []
};

exports.default = TelephoneModal;


// WEBPACK FOOTER //
// ./components/doctify-modals/lib/components/telephone-modal.js